<p-panel>
	<app-reactive-form-builder
		(formChanges)="formChanges($event[0], $event[1])"
		(goBack)="goBack()"
		[form]="form.formFields"
		[id]="getModel().id ?? ''"
		[request]="this.getType() === 1 ? this.productApi.productos.PUT : this.productApi.productos.POST"
		[getRequest]="productApi.productos.GET"
		[dropdownLoadTrigger]="dropdownLoadTrigger"
		[dropdownsFinalized]="dropdownsFinalized"
	>
	</app-reactive-form-builder>
</p-panel>
